import * as actionTypes from './actionTypes'

export function updateReconField(field, payload) {
  return {
    type: actionTypes.UPDATE_RECON_FIELD,
    payload,
    field
  }
}
export function updateReconDate(object, field, value) {
  return {
    type: actionTypes.UPDATE_RECON_DATE,
    value,
    field,
    object
  }
}

export function saveReconField(field, payload) {
  return {
    type: actionTypes.SAVE_RECON_FIELD,
    field,
    payload
  }
}


export function updateReconErrorWarning(warnings) {
  return {
    type: actionTypes.UPDATE_RECON_INFO_WARNING,
    warnings
  }
}
